import Labels from '../enums/Labels';
import { FieldInputProps, FieldMetaState } from 'react-final-form';
import { TafChangeEvent } from '@taf-ui/core';

export type Props = {
  label?: Labels;
  trustedLabel?: string;
  placeholder?: Labels;
  isRequired?: boolean;
  showRequiredAsterisk?: boolean;
  wrapperClass?: string;
  labelWrapperClass?: string;
  inputWrapperClass?: string;
  meta: FieldMetaState<string>;
  input: FieldInputProps<string>;
  onBlurHandler?: (e: CustomEvent<TafChangeEvent<number | string>>) => void;
  onChangeHandler?: (e: CustomEvent<TafChangeEvent<number | string | boolean>>) => void;
  disabled?: boolean;
} & Partial<DefaultProps>;

export const defaultProps = {
  placeholder: '',
  label: '',
  trustedLabel: '',
  isRequired: false,
  showRequiredAsterisk: true,
  wrapperClass: '',
  labelWrapperClass: '',
  inputWrapperClass: '',
  maxValueLength: 0,
};

export type DefaultProps = Readonly<typeof defaultProps>;

export type DecimalProps = {
  decimalsAreAllowed: boolean;
};
